export const VERSION = 'v1'
export const LOGIN_URL = `/${VERSION}/tenant/login`
export const LOGOUT_URL = `/${VERSION}/tenant/logout`
export const REFRESH_TOKEN_URL = `/${VERSION}/tenant/refresh`
export const RESET_PASS = `/${VERSION}/auth/reset-password`
export const FORGOT_PASS = `/${VERSION}/tenant/forgot-password`
export const PAYMENT_INTENT_URL = `/ri/${VERSION}/payment/payment-intent`